// Chakra imports
import { Flex, Text, useColorModeValue, Image } from '@chakra-ui/react';

// Custom components
import beeStockedLogo from 'assets/img/layout/beeStockedLogo.png';
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand(props: { mini: boolean; hovered: boolean }) {
  const { mini, hovered } = props;
  //   Chakra color mode
  let logoColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex alignItems="center" flexDirection="column">
      <Image src={beeStockedLogo} alt="BeeStocked Logo" width="250px" padding={'10px'}/>
      <Text
        display={
          mini === false
            ? 'none'
            : mini === true && hovered === true
            ? 'none'
            : 'block'
        }
        fontSize={'30px'}
        fontWeight="800"
        color={logoColor}
      >
        H
      </Text>
      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
